module.exports = __webpack_public_path__ + "static/00009.e62cfc42.jpg";